import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createFaqItemBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getSalesBlockPrimaryStyleOptions } from "../constants";

const questions = [
  {
    question: "How is this different from other coaching programs?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
  {
    question: "How much time will I need to commit each week?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
  {
    question: "Will this work for my specific situation?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
  {
    question: "How soon will I see results?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
  {
    question: "Do you offer payment plans?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
  {
    question: "What happens after the 12-week program ends?",
    answer:
      "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock11",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Frequently Asked Questions",
        }),
        createPBlock({
          text: "Everything you need to know about the coaching program.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: questions.map(item => createFaqItemBlock(item)),
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Have more questions? I'm happy to answer them personally.",
          paragraphStyle: "p3",
        }),
        createButtonBlock({
          text: "Contact Me Directly",
          href: "#",
          buttonType: "primaryButton",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
      },
    },
  },
};
